import script from "./DashboardUserPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardUserPage.vue?vue&type=script&setup=true&lang=js"

import "./DashboardUserPage.vue?vue&type=style&index=0&id=74e106f0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74e106f0"]])

export default __exports__